<template>
  <div class="the-picture-editor">
    <the-picture-editor-crop
      class="the-picture-editor__source"
      :fileName="fileName"
      @preview="preview"
    />
  </div>
</template>

<script>
import ThePictureEditorCrop from "./ThePictureEditorCrop.vue";

import { mapState, mapMutations } from "vuex";

export default {
  name: "ThePictureEditor",
  props: {
    fileName: String
  },
  components: {
    ThePictureEditorCrop
  },
  data() {
    return {};
  },
  computed: {
    ...mapState({
      cropImg: state => state.thePictureEditor.cropImg
    })
  },
  methods: {
    ...mapMutations(["recalcAspectRatio"]),
    preview() {
      this.$emit("preview");
    }
  },
  created() {
    this.recalcAspectRatio();
  }
};
</script>

<style lang="scss" scoped>
.the-picture-editor {
  box-sizing: border-box;

  .the-picture-editor__source {
    height: 100%;
  }

  .the-picture-editor__params {
    margin-top: 15px;
  }
}
</style>
